export const atobDecoding = (data) => {
  return Buffer.from(data, "base64").toString();
};

export const getDecodedValue = (key, data) => {
  const urlParams = new URLSearchParams(atobDecoding(data));
  return urlParams.get(key);
};

export const redirectTo = (url) => {
  window.location.href = url;
};
